import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=198f8674&scoped=true"
import script from "./backtop.vue?vue&type=script&lang=js"
export * from "./backtop.vue?vue&type=script&lang=js"
import style0 from "./backtop.vue?vue&type=style&index=0&id=198f8674&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f8674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198f8674')) {
      api.createRecord('198f8674', component.options)
    } else {
      api.reload('198f8674', component.options)
    }
    module.hot.accept("./backtop.vue?vue&type=template&id=198f8674&scoped=true", function () {
      api.rerender('198f8674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout/backtop.vue"
export default component.exports